import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M9.99 1.567a8.422 8.422 0 0 1 6.462 13.824l5.443 5.444a.75.75 0 1 1-1.06 1.06l-5.444-5.443A8.422 8.422 0 1 1 9.99 1.567zm0 1.5a6.922 6.922 0 1 0 4.884 11.828l.01-.012a6.897 6.897 0 0 0 2.028-4.894c0-3.823-3.099-6.922-6.922-6.922z' />
  </svg>
);
